<template>
  <billing-report-panel
    report-key="production-expense"
    route="/reports/billing-production-expense"
    file-name="producao-por-procedimento.xlsx"
    period-label="Período do atendimento"
    :columns="columns"
    :default-days="30"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio',
        'Código do procedimento',
        'Procedimento',
        'Tabela',
        'Quantidade realizada',
        'Valor unitário médio',
        'Valor total',
        'Subtotal por convênio',
      ],
    };
  },
};
</script>
